var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFullAlt1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#33363f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m20 20v1h1v-1zm-4.2929-5.7071c-.3905-.3905-1.0237-.3905-1.4142 0s-.3905 1.0237 0 1.4142zm3.2929-.2929v6h2v-6zm1 5h-6v2h6zm.7071.2929-5-5-1.4142 1.4142 5 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4 20h-1v1h1zm5.70711-4.2929c.39049-.3905.39049-1.0237 0-1.4142-.39053-.3905-1.02369-.3905-1.41422 0zm-6.70711-1.7071v6h2v-6zm1 7h6v-2h-6zm.70711-.2929 5-5-1.41422-1.4142-5 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20 4h1v-1h-1zm-5.7071 4.29289c-.3905.39053-.3905 1.02369 0 1.41422.3905.39049 1.0237.39049 1.4142 0zm6.7071 1.70711v-6h-2v6zm-1-7h-6v2h6zm-.7071.29289-5 5 1.4142 1.41422 5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4 4v-1h-1v1zm4.29289 5.70711c.39053.39049 1.02369.39049 1.41422 0 .39049-.39053.39049-1.02369 0-1.41422zm-3.29289.29289v-6h-2v6zm-1-5h6v-2h-6zm-.70711-.29289 5 5 1.41422-1.41422-5-5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullAlt1);
export default __webpack_public_path__ + "static/media/full-alt-1.836416f6989196c87818051acfb9d724.svg";
export { ForwardRef as ReactComponent };